import { useCallback, useState } from 'react';
import Button from '@common/components/controls/Button';
import GuidedTourPopupComponent from '@common/components/GuidedTourPopup/GuidedTourPopupComponent';
import GuidedTourView from '@common/components/GuidedTourPopup/GuidedTourView';
import Translated from '@common/components/Translated';
import { type GuidedTour } from '@common/types/guidedTour';

interface GuidedTourPopupProps {
  steps: GuidedTour['steps'];
  onClose: () => void;
}

function GuidedTourPopup({ steps, onClose }: Readonly<GuidedTourPopupProps>) {
  const [step, setStep] = useState(0);
  const tourStep = steps[step];

  const stepForward = useCallback(() => {
    setStep((currentStep) => Math.min(steps.length - 1, currentStep + 1));
  }, [steps]);
  const stepBack = useCallback(() => {
    setStep((currentStep) => Math.max(0, currentStep - 1));
  }, []);

  return (
    <GuidedTourPopupComponent
      buttons={(
        <>
          {step === 0
            ? (
              <Button
                type="button"
                mode="text"
                onClick={onClose}
                data-testid="tourButton.skip"
              >
                <Translated id="tour.button.skip" />
              </Button>
            )
            : (
              <Button
                type="button"
                mode="text"
                onClick={stepBack}
                data-testid="tourButton.step-prev"
              >
                <Translated id="tour.button.prev" />
              </Button>
            )}
          {step === 0 && (
            <Button
              onClick={stepForward}
              data-testid="tourButton.start"
            >
              <Translated id="tour.button.start" />
            </Button>
          )}
          {step === steps.length - 1 && (
            <Button
              onClick={onClose}
              data-testid="tourButton.finish"
            >
              <Translated id="common.actions.close" />
            </Button>
          )}
          {step > 0 && step < steps.length - 1 && (
            <Button
              onClick={stepForward}
              data-testid="tourButton.next"
            >
              <Translated id="tour.button.next" />
            </Button>
          )}
        </>
      )}
      onClose={onClose}
    >
      <GuidedTourView step={tourStep} />
    </GuidedTourPopupComponent>
  );
}

export default GuidedTourPopup;
